import { memo } from 'react';
import { useTypingStore } from '../../store/useTypingStore';

/**
 * Subscribes to only the metrics slice of the store.
 * Renders at most once per RAF frame (60fps) during active typing.
 */
const LiveMetrics = memo(function LiveMetrics() {
  const wpm = useTypingStore((s) => s.wpm);
  const accuracy = useTypingStore((s) => s.accuracy);
  const elapsedMs = useTypingStore((s) => s.elapsedMs);
  const phase = useTypingStore((s) => s.phase);

  const seconds = Math.floor(elapsedMs / 1000);
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const timeStr = `${mins}:${String(secs).padStart(2, '0')}`;

  return (
    <div className={`live-metrics ${phase === 'idle' ? 'live-metrics--idle' : ''}`}>
      <div className="metric">
        <span className="metric-value">{wpm}</span>
        <span className="metric-label">wpm</span>
      </div>
      <div className="metric">
        <span className="metric-value">{accuracy.toFixed(1)}</span>
        <span className="metric-label">acc %</span>
      </div>
      <div className="metric">
        <span className="metric-value">{timeStr}</span>
        <span className="metric-label">time</span>
      </div>
    </div>
  );
});

export default LiveMetrics;
